export default __webpack_public_path__ + "static/media/Logo2.7f5d524d.jpg";